import { nanoid } from "@reduxjs/toolkit";
import { DEFAULT_COMBO_SETTINGS } from "./default-combos-settings";

/**
 * The "nice" blank slide used by the editor's Add slide action and by
 * blank story/deck creation (Create blank / From blank). A Simple combo with
 * a title and a paragraph placeholder. Generates fresh ids on every call so
 * it can be safely added next to existing slides.
 */
export const createBlankTitleTextSlide = () => ({
  id: nanoid(15),
  type: "slide",
  settings: {
    verticalAlignment: "start",
    horizontalAlignment: "start",
    minHeight: "screenFit",
    maxWidth: "medium",
    backgroundType: "backgroundColor",
    overlayOpacity: "100",
    mediaSrc: "",
    isHidden: false,
    analytics: "",
    backgroundColor: "var(--background-main-color)",
  },
  children: [
    {
      id: nanoid(15),
      type: "combo",
      settings: { ...DEFAULT_COMBO_SETTINGS.SIMPLE, maxWidth: "medium" },
      children: [
        {
          id: nanoid(15),
          type: "set",
          settings: {
            horizontalAlignment: "start",
            verticalAlignment: "center",
            groupsRatio: ["100", "100"],
          },
          children: [
            {
              id: nanoid(15),
              type: "group",
              settings: {},
              children: [
                {
                  id: nanoid(15),
                  type: "element",
                  settings: {
                    content: "",
                    horizontalAlignment: "start",
                    name: "RichText",
                    textStyle: "slide-title",
                    placeholder: "<h2>Click to add title</h2>",
                  },
                  children: [],
                },
              ],
            },
            {
              id: nanoid(15),
              type: "group",
              settings: {},
              children: [
                {
                  id: nanoid(15),
                  type: "element",
                  settings: {
                    content: '<p style="text-align: left;"></p>',
                    horizontalAlignment: "center",
                    name: "RichText",
                    textStyle: "normal",
                    placeholder: "<p>Click to add paragraph</p>",
                  },
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
